/*
 * @Author: Chen Zhen
 * @LastEditors: Chen Zhen
 * @Description: 时间轴 主文件
 * @Date: 2019-03-24 22:48:05
 * @LastEditTime: 2019-03-25 08:45:26
 */

import Timeline from './timeline'

export default Timeline
